<template>
  <layout-main-inner
    v-loading="loading"
    title="证书审核">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <!-- <upload-status-select v-model="config.status" /> -->
        <el-button
          style="margin-left: 10px;"
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="原始文件"
          min-width="200"
          prop="applyName"></el-table-column>
        <el-table-column
          min-width="80"
          label="证书总数"
          prop="total"></el-table-column>
        <el-table-column
          min-width="90"
          label="导入成功数"
          prop="successfulCount"></el-table-column>
        <el-table-column
          min-width="90"
          label="导入失败数"
          prop="failedCount"></el-table-column>
        <el-table-column
          min-width="90"
          label="图片导入数"
          prop="attachImageCount"></el-table-column>
        <el-table-column
          label="证书导入状态"
          min-width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.status | orderUploadStatusType1()">{{ row.status | orderUploadStatusName1() }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="完成时间"
          width="150">
          <template slot-scope="{ row }">{{ row.doneTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="80">
          <template slot-scope="{ row }">
            <el-dropdown>
              <el-button type="text">
                审核<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="downPdf(row)">下载打印文件</el-dropdown-item>
                <el-dropdown-item @click.native="auditFile(row, 7)">审核通过</el-dropdown-item>
                <el-dropdown-item @click.native="auditFile(row, 9)">审核不通过</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
// import UploadStatusSelect from './busi/upload-status-select.vue'
import { downloadBlobFile } from '@/utils/index'
export default {
  name: 'QualificationCertificateApply',
  // components: { UploadStatusSelect },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, status: 5 }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    downPdf(row) {
      this.$$JewelsApi.downloadcertfiles({ id: row.id })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    auditFile(row, status) {
      const msg = status === 9 ? '确定审核不通过？' : '确定审核通过？'
      this.$confirm(msg, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$JewelsApi.updatebatchtask({ id: row.id, status })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('审核成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$$JewelsApi.getbatchtasks(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records.map(i => ({ ...i, applyName: i.applyFileUrl.split('originalfilename')[1].slice(1) }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
